import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import {
  fetchClientByClientIdRequest,
  selectClientIsLoading,
  selectMaybeClient,
  selectSession,
} from '@client';
import { useClerkClientAuth } from '@client/hooks/useClerkClientAuth';

export const useClientData = () => {
  const { isLoading: authLoading, isAuthenticated } = useAuth0();
  const { isClerkSignedIn, isClerkLoading } = useClerkClientAuth();
  const { clientId } = useParams();
  const dispatch = useDispatch();
  const client = useSelector(selectMaybeClient);
  const clientIsLoading = useSelector(selectClientIsLoading);
  const { advisor } = useSelector(selectSession);

  const isUserAuthenticated = isAuthenticated || isClerkSignedIn;
  const isLoading = authLoading || isClerkLoading || clientIsLoading;

  const shouldBeLoadingClientData =
    !client || (!clientIsLoading && isUserAuthenticated && !advisor);

  useEffect(() => {
    if (
      clientId &&
      (!client || client.clientId !== clientId) &&
      !isLoading &&
      isUserAuthenticated
    ) {
      dispatch(fetchClientByClientIdRequest(clientId));
    }
  }, [clientId, client, dispatch, isLoading, isUserAuthenticated]);

  return {
    client,
    isLoading,
    shouldBeLoadingClientData,
    authLoading,
    clientIsLoading,
  };
};
